// prop-type is a library for typechecking of props
import PropTypes from 'prop-types'
import { useState } from 'react'
// Soft UI Dashboard PRO React components
import FormField from 'components/FormField'
import { useFieldState } from 'hooks/useFieldState'
import { NumericFormat } from 'react-number-format'

const FloatField = ({
  value,
  label,
  onChange,
  required,
  placeholder,
  onBlur,
  ...rest
}) => {
  const [rawValue, setRawValue] = useState(value)
  const validateFloat = (value) => {
    return `${value}`.match(/^\d+\.\d$/)
  }
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    validatorFunction: validateFloat,
  })
  const handleOnblurWithValidation = (value) => {
    const isValid = validateFloat(value)
    handleOnblur?.(value)
    if (isValid) {
      onBlur?.(rawValue)
    }
  }
  return (
    <>
      <NumericFormat
        value={value}
        label={label}
        placeholder={placeholder}
        fixedDecimalScale
        inputProps={{ inputMode: 'numeric' }}
        decimalScale={1}
        customInput={FormField}
        error={isError}
        success={isSuccess}
        onBlur={handleOnblurWithValidation}
        onValueChange={(values, _sourceInfo) => {
          setRawValue(values.floatValue)
          onChange(values.floatValue)
        }}
        {...rest}
      />
    </>
  )
}

// typechecking props for FloatField
FloatField.propTypes = {
  label: PropTypes.string.isRequired,
}

export default FloatField
